/**
 * User Register Listener
 * Event listener binding only
 */

import type { UserRegisterForm } from "./user-register-form";
import type { UserRegisterHandler } from "./user-register-handler";

export class UserRegisterListener {
    public form: UserRegisterForm;

    public handler: UserRegisterHandler;

    public constructor(form: UserRegisterForm, handler: UserRegisterHandler) {
        this.form = form;
        this.handler = handler;
    }

    public attach(): void {
        this.form.form.addEventListener("submit", this.handler.handleSubmit);
    }
}
